<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="part" id="part1"><a href="#/toc#part_1"><b><span class="big">1996</span></b><br/><span class="small"><i>FROM THE BICYCLE</i><br/><i>TO THE SCREEN</i></span></a></p>
<p class="ser-center"><img alt="image" src="images/bcycle.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?2e9a82f7